import React, { useState, useEffect } from 'react';
import '../../assets/scss/cme.scss';
import { getRecommendationsService } from '../../services/apiServices';
import { useSelector } from 'react-redux';
import Section from './Section';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import EmptyAlert from '../../components/EmptyAlert';
import { Helmet } from 'react-helmet';
import MetaDecorators from '../../components/MetaDecorators';

const antIcon = <LoadingOutlined style={{ fontSize: 64 }} spin />;

function CmeLanding() {
  const { domainDetails, status } = useSelector((state) => state.listings);
  const { currentCountry } = useSelector((state) => state.utilities);
  const [panels, setPanels] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (currentCountry && domainDetails && domainDetails.id) {
      fetchPanels();
    }
  }, [currentCountry, domainDetails]);

  useEffect(() => {
    if (panels) {
      panels.forEach((panel) => {
        if (panel.type !== 'CME' && panel.type !== 'EXPERT_TALK' && panel.type !== 'CONFERENCES') {
          setNoResults(true);
        } else {
          setNoResults(false);
        }
      });
    }
  }, [panels]);

  const fetchPanels = () => {
    const payload = {
      isHomePage: false,
      countryCode: currentCountry,
      organizationIds: [domainDetails.id],
      screen: 'ORGANIZATION_LANDING_PAGE',
    };
    getRecommendationsService(payload)
      .then((response) => {
        if (response.panels && response.panels.length > 0) {
          setPanels(response.panels);
        } else {
          setPanels([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };

  return (
    <div className='mainPageWapper'>
      <MetaDecorators />
      {loading && (
        <div style={{ textAlign: 'center', padding: '10%' }}>
          <Spin indicator={antIcon} />
        </div>
      )}
      <div className='sectionWrapper'>
        {panels.length > 0 ? (
          panels.map((panel) => {
            return <Section key={panel.id} sectionItems={panel} />;
          })
        ) : !loading && panels.length === 0 ? (
          <EmptyAlert />
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export default CmeLanding;
